import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filter, sortArray } from '@nu-art/ts-common';
import { ModuleFE_Variable } from '../../../_entity/variable/index.js';
import { ComponentSync, LL_H_C, SimpleListAdapter, TS_DropDown, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { VariableWrapper } from '../../../wrappers/index.js';
import { variableType_Normal } from '@app/hcs-shared';
export class DropDown_VariableWithAttribute extends ComponentSync {
    static defaultProps = {
        module: ModuleFE_Variable
    };
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        const allVars = nextProps.module.cache.filter(item => item.type === variableType_Normal);
        const allValues = [...allVars];
        if (nextProps.queryFilter)
            state.values = allValues.filter((item) => {
                nextProps.queryFilter({ variableId: item._id });
            });
        else
            state.values = allValues;
        if (nextProps.sortBy)
            state.values = sortArray(state.values, nextProps.sortBy[0]);
        if (nextProps.selected)
            state.selectedTitle = this.getTitle(nextProps.selected);
        else
            state.selectedTitle = undefined;
        return state;
    }
    getTitle(selected) {
        const base = this.props.module.cache.unique(selected.variableId)?.name ?? 'Entity Deleted';
        const property = this.props.module.cache.unique(selected.attributeId)?.name ?? 'Entity Deleted';
        return _jsx("div", { className: 'ts-dropdown__selected', style: { color: base === 'Entity Deleted' ? 'red' : '#4f4f4f' }, children: `${base}${property ? `.${property}` : ''}` });
    }
    getItems = () => {
        if (this.state.selectingAttribute) {
            return this.state.selectedVariable?._attributeVarIds?.map(attrId => this.props.module.cache.unique(attrId)) ?? [];
        }
        return this.state.values;
    };
    handleInputChange = (inputValue, dropDown) => {
        if (!inputValue.length)
            this.setState({ selectingAttribute: false, selectedVariable: undefined });
        if (inputValue.endsWith('.')) {
            const splitByDots = inputValue.split('.');
            const variable = this.state.values.find(v => v._nameInLowercase === splitByDots[0]?.toLowerCase());
            if (variable && variable._attributeVarIds?.length) {
                this.setState({ selectingAttribute: true, selectedVariable: variable }, this.forceUpdate);
            }
        }
        const splitInput = inputValue.split('.');
        // @ts-ignore
        dropDown.reDeriveState({ filterText: splitInput[splitInput.length - 1] });
    };
    handleSelection = async (value) => {
        if (this.state.selectedVariable)
            return this.props.onSelected({ variableId: this.state.selectedVariable._id, attributeId: value._id });
        this.setState({ selectingAttribute: false }, () => this.props.onSelected({ variableId: value._id }));
    };
    renderSelectedItem = () => {
        const selectedTitle = this.state.selectedTitle;
        if (!selectedTitle)
            return _jsx("div", { className: "ts-dropdown__placeholder", children: 'Pick A Variable' });
        return _jsx(LL_H_C, { style: { gap: '15px' }, className: 'ts-dropdown__selected', children: selectedTitle });
    };
    renderSearchInput = (dropDown) => {
        return _jsxs("div", { className: 'input-with-label', children: [_jsx(TS_Input, { type: "text", value: dropDown.props.inputValue, onChange: (filterText) => this.handleInputChange(filterText, dropDown), focus: true, style: { width: '100%' }, placeholder: dropDown.props.placeholder || '', onCancel: () => {
                        // @ts-ignore
                        dropDown.reDeriveState({ open: false, filterText: undefined });
                    }, onKeyDown: (e) => {
                        // @ts-ignore
                        dropDown.inputKeyEventHandler(e);
                    } }), this.state.selectedTitle] });
    };
    render() {
        const items = this.getItems();
        const filter = new Filter(i => {
            if (!i)
                return [];
            return new VariableWrapper(i).getSearchableText();
        });
        const adapter = () => SimpleListAdapter(items, i => {
            const variable = this.props.module.cache.unique(i.item);
            return _jsx(LL_H_C, { className: 'variable-dropdown-row', children: variable.name });
        });
        const dropdownProps = {
            adapter,
            selectedItemRenderer: this.renderSelectedItem,
            renderSearch: this.renderSearchInput,
            limitItems: this.props.limitItems ?? 50,
            className: 'variable-dropdown',
            filter: filter
        };
        const DropDown_VariableWithAttributes = TS_DropDown.prepareSelectable(dropdownProps);
        return DropDown_VariableWithAttributes({
            disabled: this.props.disabled,
            onSelected: (variable) => this.handleSelection(variable),
            showErrorTooltip: true
        });
    }
}
//# sourceMappingURL=Dropdown_VariableWIthAttribute.js.map